import InfoSection from "datalign-module-template/models/info-sections";
import React from "react";

const ThreeColumnsSection = ({ infoSection }: { infoSection: InfoSection }) => {
  return (
    <article className="card span-4" style={{ width: "100%" }}>
      <h3>{infoSection.name}</h3>
      <div>{infoSection.content}</div>
    </article>
  );
};

export default ThreeColumnsSection;
